import { ChargeDetailEntity } from "domain/entity/ChargeDetailMaintenance/ChargeDetailEntity";
import { ChargeQtyAdjSearchCriteria } from "domain/entity/ChargeQtyAdj/ChargeQtyAdjSearchCriteria";
import { ChargeDetailRepository } from "domain/repository/ChargeDetailMaintenance/ChargeDetailRepo";
import { ChargeQtyAdjRepository } from "domain/repository/ChargeQtyAdj/ChargeQtyAdjRepo";
import { ManualChargeDetailModel } from "presentation/model/ManualChargeMaintenance/ManualChargeDetailModel";
import { Dispatch, SetStateAction } from "react";
import BaseViewModel from "../BaseViewModel";


interface ManualChargeDetailVesselVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<ManualChargeDetailModel>> | ((value: SetStateAction<ManualChargeDetailModel>) => void),
    ],
    chargeDetailRepo: ChargeDetailRepository,
    repo: ChargeQtyAdjRepository,

}

export const ManualChargeDetailVesselVM = ({ dispatch, chargeDetailRepo, repo
}: ManualChargeDetailVesselVMProps) => {
    const [manualChargeDetailDispatch] = dispatch;

    const closeCntrCompDialog = () => {
        manualChargeDetailDispatch(prevState => {
            return {
                ...prevState,
                isShowFindVesselPanel: false,
                viewState: {
                    ...prevState.viewState,
                    isRead: !prevState.isShowFindVesselPanel,
                }
            }
        })
    }

    const onShowPanel = () => {
        manualChargeDetailDispatch(prevState => {
            return {
                ...prevState,
                isShowFindVesselPanel: true,
                //vesselCntrNos: vesselCntrNos,
                viewState: {
                    ...prevState.viewState,
                    isRead: !prevState.isShowFindVesselPanel,
                }
            }
        })
    }

    const initSearch = async (vesselSearchCriteria: ChargeQtyAdjSearchCriteria) => {
        repo.getConVslVoyForChargeQtyAdj(vesselSearchCriteria).then((data) => {
            manualChargeDetailDispatch(prevState => {
                return {
                    ...prevState,
                    manualChargeDetailVessels: data
                }
            })
        })
    }

    const apply = async (selectedRows: ChargeDetailEntity[]) => {
        manualChargeDetailDispatch(prevState => {
            return {
                ...prevState,
                isShowFindVesselPanel: false,
                viewState: {
                    ...prevState.viewState,
                    editingHeader: {
                        ...prevState.viewState.editingHeader,
                        consortiumCode: selectedRows[0]?.consortiumCode !== undefined ? selectedRows[0]?.consortiumCode : null,
                        vesselCode: selectedRows[0]?.vesselCode !== undefined ? selectedRows[0]?.vesselCode : null,
                        voyageCode: selectedRows[0]?.voyageCode !== undefined ? selectedRows[0]?.voyageCode : null,
                        vesselName: selectedRows[0]?.vesselName !== undefined ? selectedRows[0]?.vesselName : null,
                        etb: selectedRows[0]?.arrDatetime !== undefined ? selectedRows[0]?.arrDatetime : null,
                        etd: selectedRows[0]?.depDatetime !== undefined ? selectedRows[0]?.depDatetime : null,
                        operatingTml: selectedRows[0]?.operatingTml !== undefined ? selectedRows[0]?.operatingTml : null,
                        serviceCode: selectedRows[0]?.serviceCode !== undefined ? selectedRows[0]?.serviceCode : null,
                        soa: selectedRows[0]?.soa !== undefined ? selectedRows[0]?.soa : null,
                        slVesselCode: selectedRows[0]?.slVesselCode !== undefined ? selectedRows[0]?.slVesselCode : null,
                        slObVoyageCode: selectedRows[0]?.slObVoyageCode !== undefined ? selectedRows[0]?.slObVoyageCode : null,
                        slIbVoyageCode: selectedRows[0]?.slIbVoyageCode !== undefined ? selectedRows[0]?.slIbVoyageCode : null,
                        loa: selectedRows[0]?.loa !== undefined ? selectedRows[0]?.loa : null,
                    },
                    isRead: !prevState.isShowFindVesselPanel
                }
            }
        })
    }

    const coVslVoy = async (selectedRows: ChargeDetailEntity[]) => {
        manualChargeDetailDispatch(prevState => {
            return {
                ...prevState,
                viewState: {
                    ...prevState.viewState,
                    editingHeader: {
                        ...prevState.viewState.editingHeader,
                        consortiumCode: selectedRows[0]?.consortiumCode !== undefined ? selectedRows[0]?.consortiumCode : null,
                        vesselCode: selectedRows[0]?.vesselCode !== undefined ? selectedRows[0]?.vesselCode : null,
                        voyageCode: selectedRows[0]?.voyageCode !== undefined ? selectedRows[0]?.voyageCode : null,
                    },
                }
            }
        })
    }

    const updateSelectedManualChargeDetails = (rows: any[]) => {
        manualChargeDetailDispatch(prevState => {
            return {
                ...prevState,
                selectedManualChargeDetailVesselRow: rows
            }
        })
    }

    return {
        onShowPanel: onShowPanel,
        initSearch: initSearch,
        apply: apply,
        coVslVoy: coVslVoy,
        closeCntrCompDialog: closeCntrCompDialog,
        updateSelectedManualChargeDetails: updateSelectedManualChargeDetails
    }
}


